// Utility function for formatting currency
export const formatCurrency = (amount, currency = 'TL') => {
    if (amount === null || amount === undefined) return '-';
    return `${parseFloat(amount).toFixed(2)} ${currency}`;
};

// Utility function for formatting date
export const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleDateString('tr-TR');
};

// Utility function for formatting datetime
export const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleString('tr-TR');
};
